import { useAuth } from '@/lib'
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export function UserButton() {
	const { t } = useTranslation('common')
	const { user, signOut } = useAuth()

	if (!user) {
		return null
	}

	const initials = user.firstName && user.lastName
		? `${user.firstName[0]}${user.lastName[0]}`
		: user.email?.[0]?.toUpperCase() ?? '?'

	return (
		<div className="relative group z-50">
			<button
				type="button"
				className="w-8 h-8 rounded-full bg-indigo-600 text-white flex items-center justify-center text-sm font-medium cursor-pointer"
				title={user.email ?? 'User'}
			>
				{user.profilePictureUrl
					? (
						<img
							src={user.profilePictureUrl}
							alt={user.firstName ?? 'User'}
							className="w-full h-full rounded-full object-cover"
						/>
					)
					: (
						initials
					)}
			</button>
			<div className="absolute right-0 top-full pt-1 hidden group-hover:block min-w-[120px] z-50">
				<div className="bg-white rounded-md shadow-lg border border-gray-200 py-1">
					<div className="px-4 py-2 text-sm text-gray-500 border-b border-gray-100">
						{user.email}
					</div>
					<Link
						to="/account/availability"
						className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
					>
						{t('account.availability.title')}
					</Link>
					<Link
						to="/account/calendar"
						className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
					>
						{t('account.calendar.title')}
					</Link>
					<button
						type="button"
						onClick={() => void signOut()}
						className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
					>
						Sign out
					</button>
				</div>
			</div>
		</div>
	)
}
